export default __webpack_public_path__ + "static/media/placeholder.48e6255d.svg";